import { gql } from '@apollo/client';

export const GET_INVOICES_BY_SELLER = gql`
  query GetInvoicesBySeller(
    $seller_id: String!, 
    $type: String, 
    $from_date: String, 
    $to_date: String, 
    $page: Int, 
    $page_size: Int
  ) {
    getInvoicesBySeller(
      seller_id: $seller_id, 
      type: $type, 
      from_date: $from_date, 
      to_date: $to_date, 
      page: $page, 
      page_size: $page_size
    ) {
      status
      total_invoices_amount
      invoices {
        ref
        date
        journal_id
        type
        total
        status
      }
      pagination {
        page
        page_size
        total_records
        total_pages
      }
    }
  }
`;
